import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface StepState {
  value: number;
  menuClickId: number;
  previousMenuClickId: number;
}
const initialState: StepState = {
  value: 0,
  menuClickId: 0,
  previousMenuClickId: 0,
};

export const stepSlice = createSlice({
  name: "step",
  initialState,
  reducers: {
    forwardStep: (state, action: PayloadAction<number>) => {
      state.value = action.payload;
    },
    resetStep: (state) => {
      state.value = 0;
    },
    setMenuClick: (state, action: PayloadAction<number>) => {
      state.menuClickId = action.payload;
    },
    setPreviousMenuClick: (state, action: PayloadAction<number>) => {
      state.previousMenuClickId = action.payload;
    },
    resetMenu: (state) => {
      state.menuClickId = 0;
      state.previousMenuClickId = 0;
    },
  },
});

export const {
  forwardStep,
  resetStep,
  setMenuClick,
  setPreviousMenuClick,
  resetMenu,
} = stepSlice.actions;

export const selectStep = (state: RootState) => state.step.value;
// export const selectMenuClickId = (state: RootState) => state.step.menuClickId;

export default stepSlice.reducer;
